import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Size: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m629.28 330.25-179.96-.47v-179.78h30v149.86l150.04.39z' />
    <path d='m486.37 316.06 173.63-187.43c-11.8-11.63-30.79-11.5-42.43.3l-152.57 166.06 21.37 21.06z' />
    <path d='m150.72 330.25-.08-30 150.04-.39v-149.86h30v179.78z' />
    <path d='m295 315-175-186.36c11.8-11.63 30.79-11.5 42.43.3l153.94 165z' />
    <path d='m330.68 630h-30v-149.86l-150.04-.39.08-30 179.96.47z' />
    <path d='m293.63 463.94-173.63 187.43c11.8 11.63 30.79 11.5 42.43-.3l152.57-166.06-21.37-21.06z' />
    <path d='m479.32 630h-30v-179.78l179.96-.47.08 30-150.04.39z' />
    <path d='m486.37 463.94 173.63 187.43c-11.8 11.63-30.79 11.5-42.43-.3l-152.57-166.06 21.37-21.06z' />
  </IconBase>
));

Size.displayName = 'Size';

export default Size;
